import { computed, ref } from "vue";
import {
    clampTeamPeoplePanelWidthPx,
    resolveTeamPeoplePanelWidthPx,
} from "../../../Helpers/panelColumnWidths";
import { persistPanelColumnWidths } from "../../../Helpers/persistPanelColumnWidths";
import { useAppState } from "../../../Stores/AppState";

/** @type {import('vue').Ref<number | null>} */
const teamPeoplePanelWidthPx = ref(null);

export function hydrateTeamPeoplePanelWidthFromUserState(widthPx) {
    const clamped = clampTeamPeoplePanelWidthPx(widthPx);

    if (clamped != null) {
        teamPeoplePanelWidthPx.value = clamped;
    }
}

export function useTeamPeoplePanelWidth() {
    const peoplePanelWidthStyle = computed(() => {
        if (teamPeoplePanelWidthPx.value == null) {
            return 0;
        }

        return `${teamPeoplePanelWidthPx.value}px`;
    });

    function setTeamPeoplePanelWidthPx(widthPx) {
        const clamped = clampTeamPeoplePanelWidthPx(widthPx);

        if (clamped != null) {
            teamPeoplePanelWidthPx.value = clamped;
        }
    }

    function persistTeamPeoplePanelWidthPx(widthPx) {
        const clamped = clampTeamPeoplePanelWidthPx(widthPx);

        if (clamped == null) {
            return Promise.resolve();
        }

        teamPeoplePanelWidthPx.value = clamped;
        const app_state_store = useAppState();

        return persistPanelColumnWidths({
            team_people_panel_width_px: clamped,
        }).then(() => {
            app_state_store.team_people_panel_width_px = clamped;
        });
    }

    function hasPersistedOrExplicitWidth() {
        return teamPeoplePanelWidthPx.value != null;
    }

    return {
        teamPeoplePanelWidthPx,
        peoplePanelWidthStyle,
        setTeamPeoplePanelWidthPx,
        persistTeamPeoplePanelWidthPx,
        hasPersistedOrExplicitWidth,
        resolveTeamPeoplePanelWidthPx,
    };
}
